import { TaxesModel } from "../sociedades/model-202/model-202.model";

export class Taxes180Model extends TaxesModel {
  page1_Num_5_8: string = "";
  page1_Num_9_17: string = "";
  page1_Num_18_57: string = "";
  page1_Num_59_67: string = "";
  page1_Num_68_107: string = "";

  page1_Num_108_120: string = "";
  page1_Num_121: boolean = false;
  page1_Num_122: boolean = false;
  page1_Num_123_135: string = "";

  page1_Num_136_144: number = 0;
  page1_Num_145_160: number = 0;
  page1_Num_161_175: number = 0;

  perceptores: Taxes180Perceptor[] = [];


  constructor() {
    super();
    this.modelo = "180";

  }
}

export interface Taxes180Perceptor {
  // Operación
  nifPerceptor: string;
  nifRepresentante?: string;
  nombrePerceptor: string;
  ejercicioDevengo?: string;
  codigoProvinciaPerceptor?: string;
  modalidad?: string;

  baseAnual: number;
  porcentajeRetencion?: number;
  retencionAnual: number;

  // Inmueble
  situacionInmueble?: string;
  referenciaCatastral?: string;

  streetTypeId?: number | null;
  address?: string;

  numberingTypeId?: number | null;
  number?: string;
  numberQualifier?: string | null;
  block?: string | null;
  entrance?: string | null;
  staircase?: string | null;
  floor?: string | null;
  door?: string | null;
  complement?: string | null;

  locationId?: number | null;
  localidad?: string | null;
  municipio?: string | null;
  streetTypeDesc?: string | null;
  numberingTypeDesc?: string | null;
  municipalityCode?: string | null;
  provinceCode?: string | null;
  postalCode?: string | null;
}
